import React from 'react';
import { Grid, makeStyles, Button } from '@material-ui/core';
import { Theme } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { Steps } from '../PreJoinScreens';

const useStyles = makeStyles((theme: Theme) => ({
  googleButton: {
    background: 'white',
    color: 'rgb(0, 94, 166)',
    borderRadius: '4px',
    border: '2px solid rgb(2, 122, 197)',
    margin: '1.8em 0 0.7em',
    textTransform: 'none',
    boxShadow: 'none',
    padding: '0.3em 1em',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '&:hover': {
      background: 'white',
      boxShadow: 'none',
    },
  },
  errorMessage: {
    color: 'red',
    display: 'flex',
    alignItems: 'center',
    margin: '1em 0 0.2em',
    '& svg': {
      marginRight: '0.4em',
    },
  },
  gutterBottom: {
    marginBottom: '1em',
  },
  passcodeContainer: {
    minHeight: '120px',
  },
  submitButton: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  fileButtonLoadingSpinner: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: '40px',
  },
  rejoinButton: {
    marginTop: '10px',
  },
}));

interface CallEndedScreenProps {
  setStep: (step: Steps) => void;
}
export default function CallEndedScreen({ setStep }: CallEndedScreenProps) {
  const classes = useStyles();
  //const { signIn, user, isAuthReady } = useAppState();
  //const history = useHistory();
  //const location = useLocation<{ from: Location }>();

  return (
    <>
      <Typography variant="h5" className={classes.gutterBottom}>
        Call Ended
      </Typography>
      <form>
        <Grid container justifyContent="space-between">
          <Grid container justifyContent="flex-end"></Grid>
        </Grid>
        <Grid container justifyContent="flex-end">
          Thank you for using My Emergency Doctor
        </Grid>
        <Grid container justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setStep(Steps.deviceSelectionStep);
              window.sessionStorage.setItem('endSession', 'false');
            }}
            className={classes.rejoinButton}
          >
            Call Doctor
          </Button>
        </Grid>
      </form>
    </>
  );
}
